module.exports = __webpack_public_path__ + "img/coors-light-landing-gal-5.7a738a83.jpg";